<color-saturation-picker [color]="parsedColor" (change)="handleChange($event)"></color-saturation-picker>

<div class="color-picker-controls">
  <ng-container *ngIf="supportEyeDropper">
    <color-icon-button>
      <button type="button" (click)="openEyeDropper($event)">
        <svg viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M19.35,11.72L17.22,13.85L15.81,12.43L8.1,20.14L3.5,22L2,20.5L3.86,15.9L11.57,8.19L10.15,6.78L12.28,4.65L19.35,11.72M16.76,3C17.93,1.83 19.83,1.83 21,3C22.17,4.17 22.17,6.07 21,7.24L19.08,9.16L14.84,4.92L16.76,3M5.56,17.03L4.5,19.5L6.97,18.44L14.4,11L13,9.6L5.56,17.03Z"
          />
        </svg>
      </button>
    </color-icon-button>
  </ng-container>

  <button class="color-preview" type="button" (click)="copyColor()">
    <div class="color-preview-bg" [style.background-color]="value"></div>
    <div class="color-preview-backdrop">
      <ng-container *ngIf="isCopied; else copyIcon">
        <svg viewBox="0 0 24 24">
          <path fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
        </svg>
      </ng-container>
      <ng-template #copyIcon>
        <svg viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"
          />
        </svg>
      </ng-template>
    </div>
  </button>

  <div class="color-hue-alpha">
    <color-hue-slider [color]="parsedColor" (change)="handleChange($event)"></color-hue-slider>

    <ng-container *ngIf="!hideAlpha">
      <color-alpha-slider [color]="parsedColor" (change)="handleChange($event)"></color-alpha-slider>
    </ng-container>
  </div>
</div>

<div class="color-picker-controls">
  <color-input-fields
    [color]="parsedColor"
    [hideAlpha]="hideAlpha"
    [(format)]="format"
    (valueChange)="handleChange($event)"
    (formatChange)="handleFormatChange()"
  ></color-input-fields>
</div>
